var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',{attrs:{"src":_vm.src,"fit":_vm.fit,"alt":_vm.alt}},[_c('img',{attrs:{"slot":"error","src":require("@/assets/default.png"),"fit":"contain","width":"100%"},slot:"error"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-975f1cd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/CustomImage.vue
// module id = null
// module chunks = 